module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("退换货详情")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退换货编号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.aftersales_bn))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("申请时间:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.aftersalesInfo.create_time, 'yyyy-MM-dd hh:mm:ss')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("申请处理进度:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.aftersalesInfo.progress == '0') ? _c('span', [_vm._v(" 等待商家处理")]) : (_vm.aftersalesInfo.progress == '1') ? _c('span', [_vm._v("商家接受申请，等待消费者回寄")]) : (_vm.aftersalesInfo.progress == '2') ? _c('span', [_vm._v("消费者回寄，等待商家收货确认")]) : (_vm.aftersalesInfo.progress == '3') ? _c('span', [_vm._v("售后已驳回")]) : (_vm.aftersalesInfo.progress == '4') ? _c('span', [_vm._v("售后已处理")]) : (_vm.aftersalesInfo.progress == '5') ? _c('span', [_vm._v("退款驳回")]) : (_vm.aftersalesInfo.progress == '6') ? _c('span', [_vm._v("退款已处理")]) : (_vm.aftersalesInfo.progress == '7') ? _c('span', [_vm._v("售后关闭")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退换货类型:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.aftersalesInfo.aftersales_type == 'ONLY_REFUND') ? _c('span', [_vm._v("仅退款 ")]) : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.aftersales_type == 'REFUND_GOODS') ? _c('span', [_vm._v("退货退款 ")]) : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.aftersales_type == 'EXCHANGING_GOODS') ? _c('span', [_vm._v("换货 ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("订单编号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.order_id))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("商家名称:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.receiver_name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("订单状态:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.orderInfo.order_status == 'DONE') ? _c('span', [_vm._v("订单完成")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_status == 'NOTPAY') ? _c('span', [_vm._v("未支付")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_status == 'PAYED') ? _c('span', [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_status == 'CANCEL') ? _c('span', [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('span', [_vm._v("待用户收货")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("会员信息:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.mobile))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("下单时间:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.orderInfo.create_time, 'yyyy-MM-dd hh:mm:ss')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("收货信息:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.receiver_state) + _vm._s(_vm.orderInfo.receiver_city) + _vm._s(_vm.orderInfo.receiver_district) + _vm._s(_vm.orderInfo.receiver_address))])], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.orderInfo.items
      }
    }, [_c('el-table-column', {
      staticClass: "goods-img",
      attrs: {
        "prop": "pic",
        "label": "商品图片",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_c('img', {
            attrs: {
              "src": _vm.wximageurl + scope.row.pic,
              "alt": scope.row.item_name
            }
          })])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_spec_desc",
        "label": "规格",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量",
        "width": "180"
      }
    }), _vm._v(" "), ('point' != _vm.tradeInfo.payType) ? _c('el-table-column', {
      attrs: {
        "label": "总价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("￥" + _vm._s(scope.row.total_fee / 100))])]
        }
      }], null, false, 3495371341)
    }) : _c('el-table-column', {
      attrs: {
        "label": "总价(积分)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row.point))])]
        }
      }])
    }), _vm._v(" "), (_vm.orderInfo.delivery_status == 'DONE' && !_vm.orderInfo.delivery_corp) ? [_c('el-table-column', {
      attrs: {
        "label": "发货状态"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("已发货")])]
        }
      }], null, false, 1882035535)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "快递公司"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(_vm.dlycorpskn[scope.row.delivery_corp]))])]
        }
      }], null, false, 2948396836)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "快递单号"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row.delivery_code))])]
        }
      }], null, false, 299194888)
    })] : _vm._e()], 2)]
  ], 2)], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退货理由:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.reason))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("问题描述:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.description))])], 1), _vm._v(" "), (_vm.aftersalesInfo.evidence_pic) ? _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("图片信息:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.aftersalesInfo.evidence_pic[0]) ? _c('ul', _vm._l((_vm.aftersalesInfo.evidence_pic), function(pic, index) {
    return _c('li', {
      key: index,
      staticClass: "artical-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + pic,
        "width": "40",
        "height": "40"
      }
    })])
  }), 0) : _c('span', [_vm._v("无图片信息")])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.aftersalesInfo.progress != '0') ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("审核状态:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.aftersalesInfo.progress == '1') ? _c('span', [_vm._v("商家接受申请，等待消费者回寄")]) : (_vm.aftersalesInfo.progress == '2') ? _c('span', [_vm._v("消费者回寄，等待商家收货确认")]) : (_vm.aftersalesInfo.progress == '3') ? _c('span', [_vm._v("售后已驳回")]) : (_vm.aftersalesInfo.progress == '4') ? _c('span', [_vm._v("售后已处理")]) : (_vm.aftersalesInfo.progress == '5') ? _c('span', [_vm._v("退款驳回")]) : (_vm.aftersalesInfo.progress == '6') ? _c('span', [_vm._v("退款已处理")]) : (_vm.aftersalesInfo.progress == '7') ? _c('span', [_vm._v("售后关闭")]) : _vm._e()])], 1), _vm._v(" "), (_vm.aftersalesInfo.memo) ? _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("备注:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.memo))])], 1) : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.refuse_reason) ? _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("商家处理申请说明:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.refuse_reason))])], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.refundInfo.refund_fee) ? [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退款金额:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.refundInfo.refund_fee))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退款状态:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.refundInfo.refund_status == 'SUCCESS') ? _c('span', [_vm._v("\n            退款成功\n          ")]) : (_vm.refundInfo.refund_status == 'REFUNDCLOSE') ? _c('span', [_vm._v("\n            退款关闭。\n          ")]) : (_vm.refundInfo.refund_status == 'PROCESSING') ? _c('span', [_vm._v("\n            退款处理中\n          ")]) : (_vm.refundInfo.refund_status == 'CHANGE') ? _c('span', [_vm._v("\n            退款异常\n          ")]) : _vm._e()])], 1), _vm._v(" "), (_vm.refundInfo.refunds_memo) ? _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("退款备注:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.refundInfo.refunds_memo))])], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.aftersales_type == 'EXCHANGING_GOODS' && _vm.aftersalesInfo.progress == '4') ? [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("买家收货信息:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.aftersales_bn))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流公司:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.aftersales_bn))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流单号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.aftersales_bn))])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.sendback_data) ? [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流公司:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.dlycorpskn[_vm.aftersalesInfo.sendback_data.corp_code]))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流单号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.sendback_data.logi_no))])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.sendconfirm_data) ? [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流公司:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.dlycorpskn[_vm.aftersalesInfo.sendconfirm_data.corp_code]))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("物流单号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.aftersalesInfo.sendconfirm_data.logi_no))])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.progress == '1' || _vm.aftersalesInfo.progress == '2') ? [(_vm.aftersalesInfo.aftersales_type == 'EXCHANGING_GOODS') ? [_vm._m(9), _vm._v(" "), _c('div', [_c('el-row', {
    staticClass: "agreen-info"
  }, [_c('el-col', {
    staticClass: "col-3 agreen-right",
    attrs: {
      "span": 2
    }
  }, [_vm._v("物流公司:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入物流公司",
      "clearable": ""
    },
    model: {
      value: (_vm.corp_code),
      callback: function($$v) {
        _vm.corp_code = $$v
      },
      expression: "corp_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-3 agreen-right",
    attrs: {
      "span": 2
    }
  }, [_vm._v("物流单号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入物流单号",
      "clearable": ""
    },
    model: {
      value: (_vm.logi_no),
      callback: function($$v) {
        _vm.logi_no = $$v
      },
      expression: "logi_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendBackAction
    }
  }, [_vm._v("确认发货")])], 1)] : (_vm.aftersalesInfo.aftersales_type == 'REFUND_GOODS') ? [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [
    [_c('el-row', [_c('el-col', {
      staticClass: "col-3 content-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v("处理结果:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [(_vm.IsBind) ? [_c('el-radio', {
      attrs: {
        "label": "0",
        "disabled": ""
      },
      model: {
        value: (_vm.check_refund),
        callback: function($$v) {
          _vm.check_refund = $$v
        },
        expression: "check_refund"
      }
    }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "1",
        "disabled": ""
      },
      model: {
        value: (_vm.check_refund),
        callback: function($$v) {
          _vm.check_refund = $$v
        },
        expression: "check_refund"
      }
    }, [_vm._v("同意")])] : [_c('el-radio', {
      attrs: {
        "label": "0"
      },
      model: {
        value: (_vm.check_refund),
        callback: function($$v) {
          _vm.check_refund = $$v
        },
        expression: "check_refund"
      }
    }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "1"
      },
      model: {
        value: (_vm.check_refund),
        callback: function($$v) {
          _vm.check_refund = $$v
        },
        expression: "check_refund"
      }
    }, [_vm._v("同意")])]], 2)], 1), _vm._v(" "), (_vm.aftersalesInfo.aftersales_type != 'EXCHANGING_GOODS' && _vm.check_refund == '1') ? [_c('el-row', [_c('el-col', {
      staticClass: "col-3 content-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v("退款金额:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.orderInfo.total_fee / 100,
        "step": "0.1"
      },
      model: {
        value: (_vm.refund_fee),
        callback: function($$v) {
          _vm.refund_fee = $$v
        },
        expression: "refund_fee"
      }
    })], 1)], 1)] : _vm._e(), _vm._v(" "), (this.check_refund == '0') ? _c('el-row', [_c('el-col', {
      staticClass: "col-3 agreen-right",
      attrs: {
        "span": 2
      }
    }, [_vm._v("拒绝原因:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入拒绝原因"
      },
      model: {
        value: (_vm.refuse_reason),
        callback: function($$v) {
          _vm.refuse_reason = $$v
        },
        expression: "refuse_reason"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-footer with-border content-center"
    }, [(_vm.IsBind) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": ""
      },
      on: {
        "click": _vm.refundAction
      }
    }, [_vm._v("确认")]) : _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.refundAction
      }
    }, [_vm._v("确认")])], 1)]
  ], 2)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.aftersalesInfo.progress == '0') ? [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [
    [_c('el-row', [_c('el-col', {
      staticClass: "col-3 content-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v("处理结果:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [(_vm.IsBind) ? [_c('el-radio', {
      attrs: {
        "label": "0",
        "disabled": ""
      },
      model: {
        value: (_vm.is_approved),
        callback: function($$v) {
          _vm.is_approved = $$v
        },
        expression: "is_approved"
      }
    }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "1",
        "disabled": ""
      },
      model: {
        value: (_vm.is_approved),
        callback: function($$v) {
          _vm.is_approved = $$v
        },
        expression: "is_approved"
      }
    }, [_vm._v("同意")])] : [_c('el-radio', {
      attrs: {
        "label": "0"
      },
      model: {
        value: (_vm.is_approved),
        callback: function($$v) {
          _vm.is_approved = $$v
        },
        expression: "is_approved"
      }
    }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "1"
      },
      model: {
        value: (_vm.is_approved),
        callback: function($$v) {
          _vm.is_approved = $$v
        },
        expression: "is_approved"
      }
    }, [_vm._v("同意")])]], 2)], 1), _vm._v(" "), (_vm.aftersalesInfo.aftersales_type == 'ONLY_REFUND' && _vm.is_approved == '1') ? [('point' != _vm.tradeInfo.payType) ? _c('el-row', [_c('el-col', {
      staticClass: "col-3 content-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v("退款金额:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.orderInfo.total_fee / 100
      },
      model: {
        value: (_vm.refund_fee),
        callback: function($$v) {
          _vm.refund_fee = $$v
        },
        expression: "refund_fee"
      }
    })], 1)], 1) : _c('el-row', [_c('el-col', {
      staticClass: "col-3 content-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v("退款积分:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.orderInfo.point
      },
      model: {
        value: (_vm.refund_point),
        callback: function($$v) {
          _vm.refund_point = $$v
        },
        expression: "refund_point"
      }
    })], 1)], 1)] : _vm._e(), _vm._v(" "), (this.is_approved == '0') ? _c('el-row', [_c('el-col', {
      staticClass: "col-3 agreen-right",
      attrs: {
        "span": 2
      }
    }, [_vm._v("拒绝原因:")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入拒绝原因"
      },
      model: {
        value: (_vm.refuse_reason),
        callback: function($$v) {
          _vm.refuse_reason = $$v
        },
        expression: "refuse_reason"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-footer with-border content-center"
    }, [(_vm.IsBind) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": ""
      },
      on: {
        "click": _vm.reviewSubmit
      }
    }, [_vm._v("提交审核")]) : _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.reviewSubmit
      }
    }, [_vm._v("提交审核")])], 1)]
  ], 2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("退换货信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("订单信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("退换货商品信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("售后申请信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("审核结果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("退款处理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("商家发货物流信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("用户退换货物流信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("商家发货物流信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("商家发货物流")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("商家处理信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v("商家处理信息")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-863f5170", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-863f5170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/aftersales/detail.vue
// module id = 2872
// module chunks = 0